// Où renvoyer l'utilisateur après une connexion ou une inscription.
//
// Le parcours d'achat sans compte passe par /register?next=<page de paiement> :
// une fois le compte créé, on doit reprendre l'achat là où il s'est arrêté et
// non atterrir sur le tableau de bord.

const NEXT_KEY = "sf_auth_next";

// N'accepte qu'un chemin interne. Une valeur comme "https://site-pirate.fr" ou
// "//site-pirate.fr" pourrait sinon servir à rediriger un utilisateur connecté
// vers un site externe (open redirect).
export function sanitizeNext(value) {
  const next = String(value || "").trim();
  if (!next.startsWith("/")) return "";
  if (next.startsWith("//") || next.startsWith("/\\")) return "";
  return next;
}

// Lit ?next= dans l'URL courante (ou dans la chaîne fournie).
export function getNextPath(search) {
  try {
    const params = new URLSearchParams(
      search !== undefined ? search : typeof window !== "undefined" ? window.location.search : ""
    );
    return sanitizeNext(params.get("next"));
  } catch (_) {
    return "";
  }
}

// Ajoute ?next= à un lien (utilisé pour passer d'inscription à connexion sans
// perdre l'achat en cours).
export function withNext(path, next) {
  const clean = sanitizeNext(next);
  if (!clean) return path;
  return `${path}${path.includes("?") ? "&" : "?"}next=${encodeURIComponent(clean)}`;
}

// La connexion Google quitte le site puis revient sur /auth/callback : l'URL de
// départ (et donc ?next=) est perdue. On la met de côté le temps de l'aller-retour.
export function rememberNext(next) {
  const clean = sanitizeNext(next);
  try {
    if (clean) window.sessionStorage.setItem(NEXT_KEY, clean);
    else window.sessionStorage.removeItem(NEXT_KEY);
  } catch (_) {
    /* sessionStorage indisponible : on ignore, la redirection retombera sur le défaut */
  }
}

export function consumeRememberedNext() {
  try {
    const stored = sanitizeNext(window.sessionStorage.getItem(NEXT_KEY));
    window.sessionStorage.removeItem(NEXT_KEY);
    return stored;
  } catch (_) {
    return "";
  }
}
